module.exports = __webpack_public_path__ + "media/images/icons/icn_017-3323f606ade71119947abc534a548ca5.svg";